<p>participant-summary-preview works!</p>
